import Axios from "axios";
import { action, decorate, observable } from "mobx";
import { Constant } from "../../../../config/Constant";
import { vsmNotify } from "../../../../config/messages/common";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import { convertTextToID } from "../../../../utils/GlobalFunction";

export default class ManageUsersHubStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	current_page = 1;
	list_data = null;
	editValues = null;
	deleteValues = null;
	proxynameValues = null;
	ResetPasswordValue = null;
	viewValues = null
	statusValues = null;
	total = 0;
	allColumnIds = [];
	scopeValues = null;
	dropdown_privileges_list = null;
	advance_filter = null;

	// set form values to edit
	setEditValues = async (data) => {
		this.editValues = await this.ViewData(data.id);
		//this.editValues = data;
	};

	// set form values to scope
	setScopeValues = (data) => {
		this.scopeValues = data;
	};

	// set form values to delete
	setDeleteValues = (data) => {
		this.deleteValues = data;
	};

	// set form values to proxy name
	setProxynameValues = async (data) => {
		this.proxynameValues = await this.ViewData(data.id);
	};

	// set form values to delete
	setResetPasswordValues = (data) => {
		this.ResetPasswordValue = data;
	};

	// set form values to view
	setViewValues = (data) => {
		this.viewValues = data;
	};

	setIsActiveFilterList = (data) => {
		this.isActiveFilterList = data;
	}

	setIsRistrictedFilterList = (data) => {
		this.isRistrictedFilterList = data;
	}

	setIsOtpFilterList = (data) => {
		this.isOtpFilterList = data;
	}

	setIsVerifyFilterList = (data) => {
		this.isVerifyFilterList = data;
	}

	setAccessLoactionFilterList = (data) => {
		this.accessLoactionList = data;
	}

	// set form values to status
	setStatusValues = (data) => {
		this.statusValues = data;
	};

	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	// set form values to  customefilter
	setAdvanceFilterValues = (data = null) => {
		this.advance_filter = data;
		if (this.agGrid) {
			this.setupGrid(this.agGrid);
		}
	};

	//setAdvanceFilter
	setAdvanceFilter = () => {
		let setAdvanceFilter = {};
		if (this.advance_filter) {
			if ('hubsid' in this.advance_filter) {
				setAdvanceFilter.hub_ids = this.advance_filter.hubsid.id;
			}
		}
		return setAdvanceFilter;
	}

	// call api to get records
	getList = (payload) => {
		return Axios.post(`admin/users/list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					return null;
				});
			}
			this.list_data = data.list ? data.list.data : null;
			this.total = data.list.total;
			this.current_page = data.list.current_page;
			return data;
		});
	};

	// Filter function for no record found message
	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel;
		var final_sort = params.sortModel;
		if (final_filter["is_active"]) {
			final_filter['is_active'].values = convertTextToID(final_filter['is_active'], this.isActiveFilterList, 'name', 'id')
		}
		if (final_filter["is_restricted"]) {
			final_filter['is_restricted'].values = convertTextToID(final_filter['is_restricted'], this.isRistrictedFilterList, 'name', 'id')
		}
		if (final_filter["otp_on_login"]) {
			final_filter['otp_on_login'].values = convertTextToID(final_filter['otp_on_login'], this.isOtpFilterList, 'name', 'id')
		}
		if (final_filter["is_verified"]) {
			final_filter['is_verified'].values = convertTextToID(final_filter['is_verified'], this.isVerifyFilterList, 'name', 'id')
		}
		if (final_filter["access_all_locations"]) {
			final_filter['access_all_locations'].values = convertTextToID(final_filter['access_all_locations'], this.accessLoactionList, 'name', 'id')
		}
		return { final_filter, final_sort };
	};

	// Filter function for no record found message
	onFilterChanged = (params) => {
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request);
				var advance_filter = this.setAdvanceFilter();
				var payload = {
					advance_filter: advance_filter,
					level_id: 111,
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					per_page: params.request.endRow - params.request.startRow,
					page: Math.ceil(
						(params.request.startRow + 1) /
						(params.request.endRow - params.request.startRow)
					),
				};
				this.getList(payload).then((data) => {
					if (data.list.total === 0) {
						this.agGrid.api.showNoRowsOverlay();
					} else {
						this.agGrid.api.hideOverlay();
					}
					params.successCallback(data.list.data, data.list.total);
					var allColumnIds = [];
					if (this.agGrid && this.agGrid.columnApi && data.total) {
						this.agGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.col_id);
						});
					}
				});
			},
		};
	};

	// Call add api
	AddData = (formdata, level_id) => {
		return Axios.post(`admin/users/new`, formdata)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// Call edit api
	EditData = (formdata, id) => {
		return Axios.post(`admin/users/edit/${id}`, formdata)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// Call reset Password api
	ResetPassword = (data) => {
		return Axios.post(`admin/users/reset-password`, data)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// Call reset Password api
	ResendEmail = (data) => {
		return Axios.post(`admin/users/resend-verification-email`, data)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				vsmNotify.success({
					message: data.STATUS.NOTIFICATION[0],
				});
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// Call resend registration link api
	ResendRegistrationLink = (data) => {
		return Axios.post(`admin/users/resend-registration-info`, data)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				vsmNotify.success({
					message: data.STATUS.NOTIFICATION[0],
				});
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// call api to get records
	ViewData = (ID) => {
		return Axios.get(
			`admin/users/details/${ID}`
		).then(({ data }) => {
			this.setViewValues(data.view)
			return data.view;
		});
	};

	// Call delete api
	DeleteData = (formdata) => {
		return Axios.delete(`admin/users/destroy/` + formdata.id)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	EditScopeData = (data) => {
		return Axios.post(`/admin/users/change-scope/` + data.id, data)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	}

	getPrivileges = (privileges) => {
		return Axios.post(`admin/privileges/lov/`, { level_id: Constant.AGENCY_USER })
			.then(({ data }) => {
				data.list.data.map((item) => {
					item.submenu && item.submenu.map((subitem) => {
						subitem.is_selected = privileges && privileges.includes("#" + subitem.id + "#") ? 1 : 0
						subitem.actions && subitem.actions.map((action) => {
							action.is_selected = privileges && privileges.includes("#" + action.id + "#") ? 1 : 0
							return null;
						})
						return null;
					})
					return null;
				})
				this.dropdown_privileges_list = data.list.data;
				return data;
			})
			.catch(response => {
				return Promise.reject(response)
			})
	}

	TogglePublishData = (formdata) => {
		const api_link = formdata.is_active === 1 ? "deactivate/" : "activate/";
		return Axios.patch("admin/users/" + api_link + formdata.id)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	ToggleisRecstrictData = (formdata) => {
		const api_link = formdata.is_restricted === 1 ? "disapprove/" : "approve/";
		return Axios.patch("admin/users/" + api_link + formdata.id)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	ToggleisOtpData = (formdata) => {
		const api_link = formdata.otp_on_login === 1 ? "otp-unverified/" : "otp-verified/";
		return Axios.patch("admin/users/" + api_link + formdata.id)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	ToggleisVerifyData = (formdata) => {
		const api_link = formdata.is_verified === 1 ? "unverify/" : "verify/";
		return Axios.patch("admin/users/" + api_link + formdata.id)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	verifyUserName = (username) => {
		return Axios.post(
			`admin/users/check-avail-username`, { username }
		).then(({ data }) => {

		})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	}

	JsonToFormData = (data) => {
		const formData = new FormData();
		Object.keys(data).forEach(key => {
			if (!['default_location', 'ho_ids', 'dob', 'id', 'photo', 'deleted_photo', 'deleted_aadhar_image', 'aadhar_image', 'otp_on_login', 'is_restricted'].includes(key)) {
				formData.append(key, (data[key] !== undefined && data[key] !== null) ? data[key] : '')
			}
		})
		return formData
	}
}

decorate(ManageUsersHubStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	editValues: observable,
	deleteValues: observable,
	proxynameValues: observable,
	total: observable,
	allColumnIds: observable,
	statusValues: observable,
	viewValues: observable,
	setupGrid: action,
	setPageSize: action,
	setEditValues: action,
	setDeleteValues: action,
	setProxynameValues: action,
	setResetPasswordValues: action,
	setStatusValues: action,
	getList: action,
	onFilterChanged: action,
	ViewData: action,
	setViewValues: action,
	scopeValues: observable,
	dropdown_privileges_list: observable,
	advance_filter: observable,
	setAdvanceFilterValues: action,
	setIsActiveFilterList: action,
	setIsOtpFilterList: action,
	setIsRistrictedFilterList: action,
	setIsVerifyFilterList: action,
	setAccessLoactionFilterList: action
});
